import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import SellIcon from '../../../../images/icons/sell_icon.png';

const BuyNowCeil = ({ price, description, }) => {
  const classes = useStyles();

  return (
    <div className={classes.buyNow}>
      <img alt="sell icon" src={SellIcon} className={classes.sellIcon} />
      {description}&nbsp;
      <strong> {price} &euro;</strong>
    </div>
  );
};

BuyNowCeil.propTypes = {
  price: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
};

const useStyles = createUseStyles({
  buyNow: {
    fontSize: '14px',
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '8px',
    marginTop: '5px',
    flexWrap: 'wrap',
    '& strong': {
      color: '#54515A',
      fontSize: '15px',
    },
  },
  sellIcon: {
    height: '20px',
    marginRight: '4px',
  },
});

export default BuyNowCeil;
